<template>
    <TransitionRoot as="template" :show="open">
        <Dialog
            as="div"
            static
            class="fixed inset-0 z-10 overflow-y-auto"
            :open="open"
            @close="open = false"
        >
            <div
                class="flex min-h-screen items-end justify-center px-4 pb-20 pt-4 text-center sm:block sm:p-0"
            >
                <TransitionChild
                    as="template"
                    enter="ease-out duration-300"
                    enter-from="opacity-0"
                    enter-to="opacity-100"
                    leave="ease-in duration-200"
                    leave-from="opacity-100"
                    leave-to="opacity-0"
                >
                    <DialogOverlay
                        class="fixed inset-0 bg-iron-500 bg-opacity-75 transition-opacity"
                    />
                </TransitionChild>

                <!-- This element is to trick the browser into centering the modal contents. -->
                <span
                    class="hidden sm:inline-block sm:h-screen sm:align-middle"
                    aria-hidden="true"
                    >&#8203;</span
                >
                <TransitionChild
                    as="template"
                    enter="ease-out duration-300"
                    enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    enter-to="opacity-100 translate-y-0 sm:scale-100"
                    leave="ease-in duration-200"
                    leave-from="opacity-100 translate-y-0 sm:scale-100"
                    leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                    <div
                        class="inline-block transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left align-bottom shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6 sm:align-middle"
                    >
                        <div>
                            <div class="mt-3 text-center sm:mt-5">
                                <div class="mt-2">
                                    <div class="ml-5 flex flex-col items-start">
                                        <!-- <p>
                                            <span class="font-bold"
                                                >Title:</span
                                            >
                                            {{ event.title }}
                                        </p>
                                        <p v-if="event.recurrence">
                                            <span class="font-bold"
                                                >Recurrence:</span
                                            >
                                            {{ event.recurrence }}
                                        </p>
                                        <p>
                                            <span class="font-bold"
                                                >Available Seats:</span
                                            >
                                            {{ event.available_seats }} /
                                            {{ event.seats }}
                                        </p>
                                        <p v-if="event.description">
                                            <span class="font-bold"
                                                >Description:</span
                                            >
                                            {{ event.description }}
                                        </p>
                                        <p v-if="event.short_description">
                                            <span class="font-bold"
                                                >Short Description:
                                            </span>
                                            {{ event.short_description }}
                                        </p> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="mt-5 sm:mt-6">
                            <button
                                type="button"
                                class="inline-flex w-full justify-center rounded-md border border-transparent bg-z-orange-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-z-orange-500 focus:ring-offset-2 sm:text-sm"
                                @click="open = false"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </TransitionChild>
            </div>
        </Dialog>
    </TransitionRoot>
</template>

<script lang="ts" setup>
import {
    Dialog,
    DialogOverlay,
    TransitionChild,
    TransitionRoot,
} from "@headlessui/vue";
import type { EventType } from "../types/EventType";
import { computed } from "vue";

interface Props {
    modelValue: boolean;
    event: EventType;
}

const props = withDefaults(defineProps<Props>(), {
    modelValue: false,
});

const emit = defineEmits(["update:modelValue"]);

const open = computed({
    get() {
        return props.modelValue;
    },
    set(v: boolean) {
        emit("update:modelValue", v);
    },
});
</script>

<style></style>
